// Opis kategorii – klucz z categoryId, żeby opis aktualizował się przy zmianie kategorii (bez zmian w core).
// @ts-nocheck

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError, IArticleSection } from 'api/types';

const SECTION_ID = 'CATEGORY_DESCRIPTION';

const getCategoryDescription = (categoryId: string): Promise<IArticleSection> =>
  axios.get(`/cms/articles/${SECTION_ID}/${categoryId}`);

export const useGetCategoryDescription = (
  categoryId: string,
  options?: UseQueryOptions<IArticleSection, IError>
) =>
  useQuery<IArticleSection, IError>(
    ['section-article', SECTION_ID, categoryId],
    () => getCategoryDescription(categoryId),
    options
  );
